import { useMediaQuery } from "react-responsive";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "jalali-moment";
import { ReactSession } from "react-client-session";
import { BiChevronsDown } from "react-icons/bi";
import ArchiveItem from "../../Components/ArchiveItems/ArchiveItem";
import BlogItemSlider from "../../Components/BlogItemSlider/BlogItemSlider";
import p1 from "../../Images/01.jpg";
import p2 from "../../Images/02.jpg";
import p3 from "../../Images/03.jpg";
import "./BlogArchive.css";
import useDocumentTitle from "../../Components/TitleSetter/useDocumentTitle";
function BlogArchive(props) {
    useDocumentTitle("باهم | مطالب آموزشی");
    const res1000 = useMediaQuery({ query: "(max-width : 1000px)" });
    const res800 = useMediaQuery({ query: "(max-width : 800px)" });
    const res690 = useMediaQuery({ query: "(max-width : 690px)" });
    const res600 = useMediaQuery({ query: "(max-width : 600px)" });

    const [blogPosts, setBlogPosts] = useState([]);

    useEffect(() => {
        props.header.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/posts", {
                params: {
                    perPage: 6,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                console.log(moment(res.data.data[0].updatedAt).locale("fa").format("YYYY/MM/DD"));
                // console.log(moment(res.data.data[0].updatedAt).fromNow())
                setBlogPosts(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);
    return (
        <div className="blogArchive">
            <div className="newestSection">
                <div className="newestHeader">
                    <h2>تازه ترین ها</h2>
                    <div className="dotLineNewest"></div>
                </div>
                <div className="newestContainer">
                    {blogPosts.length !== 0 ? (
                        <Link
                            to={{
                                pathname: "/post/" + blogPosts[0].id,
                                // state: {
                                //   postData: blogPosts[0],
                                // },
                            }}
                        >
                            <div className="biggerImageContainerArchive">
                                <div className="imageContainerBlog">
                                    <img alt="" className="imageArchiveHeader hb" src={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + blogPosts[0].image} />
                                    <div className="imageFooterBlog imP1HB">
                                        <h2 className="h2BigImageArchive">{blogPosts[0].title}</h2>
                                        <div className="infoImageBlog" style={{ justifyContent: "flex-start" }}>
                                            <span style={{ marginLeft: "12px" }}>نوشته شده در : </span>
                                            <span>{moment(blogPosts[0].updatedAt).locale("fa").format("YYYY/MM/DD")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ) : (
                        <div className="biggerImageContainerArchive">
                            <div className="imageContainerBlog">
                                <img alt="" className="imageArchiveHeader hb" src={""} />
                                <div className="imageFooterBlog imP1HB">
                                    <h2 className="h2BigImageArchive">{"---"}</h2>
                                    <div className="infoImageBlog">
                                        <span style={{ marginLeft: "12px" }}>نوشته شده در : </span>
                                        <span>{"---"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="TwoMore">
                        {blogPosts.length >= 2 ? (
                            <Link
                                to={{
                                    pathname: "/post/" + blogPosts[1].id,
                                }}
                            >
                                <div className="imageContainerBlog">
                                    <img alt="" className="imageArchiveHeader hs" src={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + blogPosts[1].image} />
                                    <div className="imageFooterBlog moreImp">
                                        <h2 className="h2SmalImageArchive ">{blogPosts[1].title}</h2>
                                        <div className="infoImageBlog smallerSizeArchiveSpans" style={{ justifyContent: "flex-start" }}>
                                            <span style={{ marginLeft: "8px" }}>نوشته شده در :</span>
                                            <span>{moment(blogPosts[1].updatedAt).locale("fa").format("YYYY/MM/DD")}</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ) : (
                            <div className="imageContainerBlog">
                                <img alt="" className="imageArchiveHeader hs" src={""} />
                                <div className="imageFooterBlog moreImp">
                                    <h2 className="h2SmalImageArchive ">{"---"}</h2>
                                    <div className="infoImageBlog smallerSizeArchiveSpans">
                                        <span style={{ marginLeft: "8px" }}>نوشته شده در :</span>
                                        <span>{"---"}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {blogPosts.length >= 3 ? (
                            <Link
                                to={{
                                    pathname: "/post/" + blogPosts[2].id,
                                }}
                            >
                                <div className="imageContainerBlog">
                                    <img alt="" className="imageArchiveHeader hs" src={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + blogPosts[2].image} />
                                    <div className="imageFooterBlog moreImp">
                                        <h2 className="h2SmalImageArchive ">{blogPosts[2].title}</h2>
                                        <div className="infoImageBlog smallerSizeArchiveSpans" style={{ justifyContent: "flex-start" }}>
                                            <span style={{ marginLeft: "8px" }}>نوشته شده در :</span>
                                            <span>{moment(blogPosts[2].updatedAt).locale("fa").format("YYYY/MM/DD")}</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ) : (
                            <div className="imageContainerBlog">
                                <img alt="" className="imageArchiveHeader hs" src={""} />
                                <div className="imageFooterBlog moreImp">
                                    <h2 className="h2SmalImageArchive ">{"---"}</h2>
                                    <div className="infoImageBlog smallerSizeArchiveSpans">
                                        <span style={{ marginLeft: "8px" }}>نوشته شده در :</span>
                                        <span>{"---"}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="matalebAmozeshiContainer">
                <div className="archiveFeed">
                    <div className="itemsArchiveBlog">
                        <div className="topsHeaderBlog">
                            <h3>مطالب آموزشی</h3>
                        </div>

                        {blogPosts.length !== 0 ? (
                            <div className="listItemsArchive">
                                {blogPosts.map(function (item, i) {
                                    return (
                                        <Link to={{ pathname: "/post/" + item.id }}>
                                            <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image} title={item.title} text={""} time="6" date={item.updatedAt} />
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="listItemsArchive">
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                            </div>
                        )}

                        <div className="moreButtonArchive">
                            <BiChevronsDown style={{ fontSize: "25px" }} />
                            <span>مشاهده بیشتر مطالب</span>
                        </div>
                    </div>
                    <div className="sidebarArchiveBlog">
                        <div className="topsHeaderBlog">
                            <h3>محبوب ترین ها</h3>
                        </div>
                        {blogPosts.length !== 0 ? (
                            <div className="topsItemsList">
                                {blogPosts.map(function (item, i) {
                                    return (
                                        <Link to={{ pathname: "/post/" + item.id }}>
                                            <BlogItemSlider image={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image} time={"6"} date={item.updatedAt} tag={""} title={item.title} />
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="topsItemsList">
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div style={{ marginTop: "15px" }}>
                <hr />
            </div>
            <div className="matalebAmozeshiContainer">
                <div className="archiveFeed">
                    <div className="itemsArchiveBlog">
                        <div className="topsHeaderBlog">
                            <h3>آخرین اخبار</h3>
                        </div>
                        {blogPosts.length !== 0 ? (
                            <div className="listItemsArchive">
                                {blogPosts.map(function (item, i) {
                                    return (
                                        <Link to={{ pathname: "/post/" + item.id }}>
                                            <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image} title={item.title} text={""} time="6" date={item.updatedAt} />
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="listItemsArchive">
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                                <ArchiveItem width={res600 ? "49%" : res690 ? 185 : res800 ? 210 : res1000 ? 240 : 310} image={""} title={""} text="" time="" date="" />
                            </div>
                        )}
                        <div className="moreButtonArchive">
                            <BiChevronsDown style={{ fontSize: "25px" }} />
                            <span>مشاهده بیشتر اخبار</span>
                        </div>
                    </div>
                    <div className="sidebarArchiveBlog">
                        <div className="topsHeaderBlog">
                            <h3>برترین اخبار</h3>
                        </div>
                        {blogPosts.length !== 0 ? (
                            <div className="topsItemsList">
                                {blogPosts.map(function (item, i) {
                                    return (
                                        <Link to={{ pathname: "/post/" + item.id }}>
                                            <BlogItemSlider image={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + item.image} time={"6"} date={item.updatedAt} tag={""} title={item.title} />
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="topsItemsList">
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                                <BlogItemSlider image={""} time={""} date={""} tag={""} title={""} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlogArchive;
